import * as React from 'react';

import { IVerticalOffset } from '../Container';
import { QuickLink } from './QuickLink';
import { QuickLinkRedesign } from './QuickLinkRedesign';
import { IQuickLinks } from '../../models/content.interfaces';
import styled from 'styled-components';
import { BREAK_POINTS, FadeUp } from '../../consts/style';

type WrapperProps = {
  bgColor?: string;
};

type ContainerProps = {
  verticalOffset?: number;
  redesign?: boolean;
};

const Wrapper = styled.div`
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    margin-bottom: -32px;
  }
  ${(p: WrapperProps) =>
    p.bgColor &&
    `
    background-color: ${p.bgColor};
    overflow: hidden;

    @media (min-width: ${BREAK_POINTS.MIN.SM}) {
      overflow: inherit;
    }
    `}

  ${FadeUp}
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 8px;

  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    flex-wrap: nowrap;
    margin: 0;
  }

  ${(p: ContainerProps) =>
    p.verticalOffset &&
    `
    @media (min-width: ${BREAK_POINTS.MIN.SM}) {
      position:relative;
      top: ${p.verticalOffset}px;
    }
    `}
  ${(p: ContainerProps) =>
    p.redesign &&
    `
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
    margin: 0 16px;   
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    box-sizing: border-box;
    margin: 0 32px;
  }
  @media (min-width: 1140px){
    margin: 0 auto;
  }
`}
`;

export const QuickLinks = ({
  items,
  redesign,
  verticalOffset,
  bgColor,
}: IQuickLinks & IVerticalOffset) => {
  const QuickLinkComponent = redesign ? QuickLinkRedesign : QuickLink;
  return (
    <Wrapper bgColor={bgColor}>
      <Container redesign={redesign} data-id="quick-links" verticalOffset={verticalOffset}>
        {items &&
          items.map(({ headline, buttonUrl, iconSvg }) => {
            const empty = !headline && !buttonUrl && !iconSvg;
            return empty ? null : (
              <QuickLinkComponent
                headline={headline}
                url={buttonUrl}
                icon={iconSvg}
                key={headline}
              />
            );
          })}
      </Container>
    </Wrapper>
  );
};
